module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "exposure-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "exposure-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeExposure
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.headerLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "exposure-content"
  }, [(_vm.content.lead_in) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.content.lead_in)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.content.media.sources.length)) ? _c('div', {
    staticClass: "media"
  }, [((_vm.content.media.type === 'images')) ? _c('div', {
    staticClass: "image-carousel"
  }, _vm._l((_vm.content.media.sources), function(image, idx) {
    return _c('img', {
      key: idx,
      attrs: {
        "src": image,
        "alt": ""
      }
    })
  })) : _vm._e(), _vm._v(" "), ((_vm.content.media.type === 'video')) ? _c('div', {
    staticClass: "video-player"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video', {
    attrs: {
      "id": "video-player",
      "src": _vm.content.media.sources[0],
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "controlsList": "nodownload"
    },
    domProps: {
      "muted": true
    }
  }, [_vm._v("\n                            Your browser does not support HTML5 video.\n                        ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.content.loss_example) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Loss Example")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.loss_example)
    }
  }), _vm._v(" "), _c('hr', {
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.content.maintenance_tip) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Maintenance Tip")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.maintenance_tip)
    }
  }), _vm._v(" "), _c('hr', {
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.content.pdf) ? _c('section', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.content.pdf,
      "title": "Download PDF",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackEvent('PDF Download', _vm.content.pdf)
      }
    }
  }, [_vm._v("Download PDF")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "0"
    },
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), ((_vm.service || _vm.premise)) ? _c('div', {
    staticClass: "related"
  }, [((_vm.premise)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_offpremise)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.premise)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelOffPremise
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelOffPremise)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.addCoverageLabel, 'off-premise', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_serviceline)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelServiceLine
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelServiceLine)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.addCoverageLabel, 'service-line', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()])]), _vm._v(" "), _c('exposures-carousel', {
    attrs: {
      "selectedSlug": _vm.slug
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323daf7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileContentExposure.vue
// module id = 451
// module chunks = 1